import { useEffect, useState } from "react";

const getWindowDimensions = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

export const useDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: 0,
    height: 0,
  });
  const [noWindow, setNoWindow] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions());
      };

      // attach listener
      window.addEventListener("resize", handleResize);

      // set initial values
      handleResize();

      setNoWindow(false);

      // cleanup
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const { width, height } = windowDimensions;

  return {
    width,
    height,
    isXL: width >= 1200,
    isXXL: width >= 1600,
    isLG: width >= 992,
    isMD: width >= 768,
    isSM: width >= 576,
    isXS: width < 576,
    noWindow,
  };
};
